import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IResultInviteModel, IResultNpiModel, IResultRoleModel, ResultInviteModel, ResultNpiModel, ResultRoleModel } from 'src/app/models/invites/invites.model';
import {IResultPatient, ResultPatient} from "../../models/dashboard/patient.model";

@Injectable({
  providedIn: 'root'
})
export class InvitesService {
  private API_URL = `${environment.apiUrl}/accounts/my_request_invitations/`;
  private API_URL_INVITATION_MESSAGES = `${environment.apiUrl}/accounts/my_invitations/`;

  constructor(private http: HttpClient) {}

  getInvitations(practiceId: string): Observable<ResultInviteModel> {
    const params = new HttpParams().set('practice_id', practiceId);
    return this.http.get<ResultInviteModel>(this.API_URL, { params });
  }

  getListInvitations(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<ResultInviteModel> {
    const params: any = {
      limit: limit.toString(),
      offset: offset.toString(),
      ...wheres
    };

    return this.http.get<ResultInviteModel>(this.API_URL, { params });
  }

  getInvitationsMessages(practiceId: string): Observable<ResultInviteModel> {
    const params = new HttpParams().set('practice_id', practiceId);
    return this.http.get<ResultInviteModel>(this.API_URL_INVITATION_MESSAGES, { params });
  }
    // Function to call the resend invitation API
    resendInvitation(id: number): Observable<any> {
        const url = `${environment.apiUrl}/accounts/my_request_invitations/${id}/resend_invitation/`;
        return this.http.post(url, {});  // Send a POST request with an empty body
      }

      // Function to call the cancel invitation API
      cancelInvitation(id: number): Observable<any> {
        const url = `${environment.apiUrl}/orders/request_invitation/${id}/`;
        const body = { status: 'cancelled' };  // Update with the required status
        return this.http.patch(url, body);  // Send a PATCH request with the body containing the status
      }
  // Get NPI list based on practiceId

  getNpiList(practiceId: string): Observable<ResultNpiModel> {
    const url = `${environment.apiUrl}/accounts/provider_invitation/`;
    const params = new HttpParams().set('practice_id', practiceId);
    return this.http.get<IResultNpiModel>(url, { params }).pipe(
      map(result => ResultNpiModel.fromObject(result))
    );
  }

  getRoleList(): Observable<ResultRoleModel> {
    const url = `${environment.apiAuthUrl}/security/roles/`;
    const params = new HttpParams()
      .set('practice_required', 'true')
      .set('is_invitation', 'true');
    return this.http.get<IResultRoleModel>(url, { params }).pipe(
      map(result => ResultRoleModel.fromObject(result))
    );
  }

  addInvitation(
    firstName: string,
    lastName: string,
    email: string,
    roleId: string,
    phoneNumber: string,
    npi: string,
    practiceId: string
  ): Observable<any> {
    const url = `${environment.apiUrl}/orders/generate_request_user_invitation/`;
     const requestData = npi == null ? {
        first_name: firstName,
        last_name: lastName,
        practice_id: practiceId,
        email: email,
        role_id: roleId,
        phone_number: phoneNumber,
      } : {
        first_name: firstName,
        last_name: lastName,
        practice_id: practiceId,
        email: email,
        role_id: roleId,
        phone_number: phoneNumber,
        npi: npi
      };
    return this.http.post<any>(url, requestData);
  }
    // Fetch invitation by ID
    getInvitationById(id: number): Observable<ResultInviteModel> {
      const url = `${this.API_URL}${id}/`;
      return this.http.get<ResultInviteModel>(url);
    }

    // Edit invitation method
    editInvitation(
      id: number,
      firstName: string,
      lastName: string,
      email: string,
      roleId: string,
      phoneNumber: string,
      npi: string,
      practiceId: string
    ): Observable<any> {
      const url = `${environment.apiUrl}/orders/request_invitation/${id}/`;
      const requestData = {
        first_name: firstName,
        last_name: lastName,
        practice_id: practiceId,
        email: email,
        role_id: roleId,
        phone_number: phoneNumber,
        npi: npi
      };
      return this.http.patch<any>(url, requestData);
    }
}


